/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import DashboardControllerDtoGetDashboardDataRequest from '../model/DashboardControllerDtoGetDashboardDataRequest';
import DashboardControllerDtoGetDashboardDataResponse from '../model/DashboardControllerDtoGetDashboardDataResponse';

/**
* Dashboard service.
* @module api/DashboardApi
* @version 1.0
*/
export default class DashboardApi {

    /**
    * Constructs a new DashboardApi. 
    * @alias module:api/DashboardApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiDashboardDashboardDataPost operation.
     * @callback module:api/DashboardApi~apiDashboardDashboardDataPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DashboardControllerDtoGetDashboardDataResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/DashboardControllerDtoGetDashboardDataRequest} [dashboardControllerDtoGetDashboardDataRequest] 
     * @param {module:api/DashboardApi~apiDashboardDashboardDataPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DashboardControllerDtoGetDashboardDataResponse}
     */
    apiDashboardDashboardDataPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['dashboardControllerDtoGetDashboardDataRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = DashboardControllerDtoGetDashboardDataResponse;
      return this.apiClient.callApi(
        '/api/Dashboard/DashboardData', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
